var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { GridHeaderCellWithResizeTrigger } from "./GridHeaderCellWithResizeTrigger";
import { styles } from "./styles";
export function gridColumnResizePlugin(config) {
    return function (_a) {
        var rootRef = _a.rootRef, getColumns = _a.getColumns;
        var rootLeftOffset = 0;
        var startPosition = 0;
        return {
            processColumns: function (originalColumns) {
                return originalColumns.map(function (column) {
                    return __assign(__assign({}, column), { header: function (props) {
                            return React.createElement(GridHeaderCellWithResizeTrigger, {
                                onDragStart: function (_a) {
                                    var x = _a.x;
                                    var _b, _c, _d, _e, _f, _g;
                                    startPosition = x;
                                    rootLeftOffset = (_c = (_b = rootRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().left) !== null && _c !== void 0 ? _c : 0;
                                    (_e = (_d = rootRef.current) === null || _d === void 0 ? void 0 : _d.style) === null || _e === void 0 ? void 0 : _e.setProperty('--grid-core-resize-indicator-left-position', x - rootLeftOffset + "px");
                                    (_g = (_f = rootRef.current) === null || _f === void 0 ? void 0 : _f.style) === null || _g === void 0 ? void 0 : _g.setProperty('--grid-core-resize-indicator-display', 'block');
                                },
                                onDragEnd: function (_a) {
                                    var x = _a.x;
                                    var _b, _c, _d;
                                    var resizeDelta = x - startPosition;
                                    (_c = (_b = rootRef.current) === null || _b === void 0 ? void 0 : _b.style) === null || _c === void 0 ? void 0 : _c.setProperty('--grid-core-resize-indicator-display', 'none');
                                    var allSizes = getColumns().reduce(function (acc, curr) {
                                        acc[curr.id] = curr.width || 0;
                                        if (curr.id === props.column.id) {
                                            acc[curr.id] = props.column.width + resizeDelta;
                                        }
                                        return acc;
                                    }, {});
                                    (_d = config.onResize) === null || _d === void 0 ? void 0 : _d.call(config, allSizes);
                                },
                                onMouseMove: function (_a) {
                                    var x = _a.x;
                                    var _b, _c;
                                    (_c = (_b = rootRef.current) === null || _b === void 0 ? void 0 : _b.style) === null || _c === void 0 ? void 0 : _c.setProperty('--grid-core-resize-indicator-left-position', x - rootLeftOffset + "px");
                                },
                                content: column.header(props)
                            });
                        } });
                });
            },
            containerAddons: [
                {
                    id: 'resizeIndicator',
                    order: 99,
                    render: function () { return React.createElement('div', { className: styles.indicator }); }
                }
            ]
        };
    };
}
//# sourceMappingURL=gridColumnResizePlugin.js.map